import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowDownLeft"><Path d="M5.5 8.5V18.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6 18L18 6" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowDownLeft;
